export default {
  methods: {
    sendEventGA (category, label, action) {
      this.$gtag.event(action || 'Clicked', {
        event_category: category,
        event_label: label
      });
    }
  }
}
